<template lang="pug">
v-app#cepi
    v-app-bar(app='', color='indigo', dark='')
        v-app-bar-nav-icon(@click.stop='drawer = !drawer')
        v-toolbar-title CEPI - Test
    v-content
        v-container.blank-layout
            slot
    v-footer(color='indigo', app='')
        span.white--text © 2019
    
</template>

<script>

  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      vary: false,
      menu: [],
      user: ''
    }),
    created(){
        var user =  JSON.parse(localStorage.getItem('user'));
        this.user = ` -- Usuario : ${user.email} - Administrador` ? user.admin : ` Usuario : ${user.email} `;
        if(user){
            if(user.admin){
                this.menu = [
                    { text: 'Home', route:'home' },
                    { text: 'Manage', route:'', submenu: [
                        { text: 'Users', route:'usersadmin' },
                        { text: 'Create Users', route:'manageUsers' },
                        { text: 'Categories', route:'categories' },
                        { text: 'Subcategories', route:'subcategories' },
                        { text: 'Levels', route:'levels' },
                        { text: 'Questions', route:'questions' },
                        { text: 'Exams', route:'exams' }
                    ] },
                    { text: 'Reports', route:'home' }

                ]
            }else{
                this.menu = [
                    { text: 'Home', route:'home' },
                    { text: 'Profile', route:'userProfile' },
                    { text: 'Reports', route:'home' },
                    { text: 'Exams', route:'home' }
                ]
            }
        }
    },
    methods: {
        nav(route){
            this.$router.push({ name: route })
        }
    }
  }
</script>

<style>
.menu_p{
    font-size: 1rem !important;
}

.submenu-on{
    background: rgb(100, 112, 149, 0.2);
    color: white;
}

.blank-layout{
    background: rgb(196, 195, 195);
    margin: 0;
    max-width: none;
}
</style>
